import React from 'react';
import styles from '../../utils/styles/components/Footer/style.module.css';

const SocialIcon = ({ platform }) => {
  if (platform === 'instagram') {
    return (
      <svg aria-hidden="true" className={styles.socialIconSvg} viewBox="0 0 24 24">
        <rect fill="none" height="16" rx="4.5" ry="4.5" stroke="currentColor" strokeWidth="1.8" width="16" x="4" y="4" />
        <circle cx="12" cy="12" fill="none" r="3.7" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="17.3" cy="6.8" fill="currentColor" r="1.2" />
      </svg>
    );
  }

  if (platform === 'facebook') {
    return (
      <svg aria-hidden="true" className={styles.socialIconSvg} viewBox="0 0 24 24">
        <path d="M13.2 20v-6.3h2.2l.4-2.7h-2.6V9.3c0-.8.2-1.3 1.3-1.3h1.4V5.6c-.2 0-1.1-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.9V11H7.8v2.7h2.2V20h3.2z" fill="currentColor" />
      </svg>
    );
  }

  if (platform === 'youtube') {
    return (
      <svg aria-hidden="true" className={styles.socialIconSvg} viewBox="0 0 24 24">
        <path d="M21 8.4a2.8 2.8 0 00-2-2C17.3 6 12 6 12 6s-5.3 0-7 .4a2.8 2.8 0 00-2 2A29 29 0 002.6 12 29 29 0 003 15.6a2.8 2.8 0 002 2c1.7.4 7 .4 7 .4s5.3 0 7-.4a2.8 2.8 0 002-2 29 29 0 00.4-3.6 29 29 0 00-.4-3.6z" fill="none" stroke="currentColor" strokeWidth="1.6" />
        <path d="M10 9.2l5 2.8-5 2.8V9.2z" fill="currentColor" />
      </svg>
    );
  }

  if (platform === 'linkedin') {
    return (
      <svg aria-hidden="true" className={styles.socialIconSvg} viewBox="0 0 24 24">
        <path d="M6.2 8.2a1.8 1.8 0 110-3.6 1.8 1.8 0 010 3.6zM4.7 9.8h3V19h-3V9.8zm5 0h2.9v1.3h.1c.4-.8 1.4-1.6 2.9-1.6 3.1 0 3.7 2 3.7 4.7V19h-3v-4.2c0-1 0-2.3-1.4-2.3s-1.6 1.1-1.6 2.2V19h-3V9.8z" fill="currentColor" />
      </svg>
    );
  }

  if (platform === 'tiktok') {
    return (
      <svg aria-hidden="true" className={styles.socialIconSvg} viewBox="0 0 24 24">
        <path d="M14.6 4c.3 1.8 1.4 3.1 3.2 3.6v2.4a5.7 5.7 0 01-3.2-1V15a4.6 4.6 0 11-4.6-4.6c.4 0 .8.1 1.2.2v2.5a2.5 2.5 0 10.9 1.9V4h2.5z" fill="currentColor" />
      </svg>
    );
  }

  return null;
};

const socialLinks = [
  {
    href: 'https://www.instagram.com/sylviewillmsstable/',
    id: 'instagram-stable',
    label: 'Instagram Stable',
    platform: 'instagram',
    value: '@sylviewillmsstable'
  },
  {
    href: 'https://www.instagram.com/sylviewillmshorseshow/',
    id: 'instagram-horseshow',
    label: 'Instagram Horse Show',
    platform: 'instagram',
    value: '@sylviewillmshorseshow'
  },
  {
    href: 'https://www.facebook.com/sylviewillmshorseshow/',
    id: 'facebook',
    label: 'Facebook',
    platform: 'facebook',
    value: '@sylviewillmshorseshow'
  },
  {
    href: 'https://www.youtube.com/channel/UC4Rf6jqAOmPKupoWcrnwrCA',
    id: 'youtube',
    label: 'YouTube',
    platform: 'youtube',
    value: 'Chaîne Sylvie Willms'
  },
  {
    href: 'https://fr.linkedin.com/in/sylvie-willms-a51ab292',
    id: 'linkedin',
    label: 'LinkedIn',
    platform: 'linkedin',
    value: 'Sylvie Willms'
  },
  {
    href: 'https://www.tiktok.com/@sylviewillms',
    id: 'tiktok',
    label: 'TikTok',
    platform: 'tiktok',
    value: '@sylviewillms'
  }
];

const quickLinks = [
  { id: 'hero', label: 'Ouverture' },
  { id: 'biographie', label: 'Biographie' },
  { id: 'realisations', label: 'Réalisations' },
  { id: 'actualite', label: 'Dates' },
  { id: 'contact', label: 'Contact' }
];

function scrollToSection(sectionId) {
  const node = document.getElementById(sectionId);

  if (node) {
    node.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function openSection(sectionId) {
  if (window.location.hash !== '#/') {
    window.location.hash = '/';
    window.setTimeout(() => {
      scrollToSection(sectionId);
    }, 80);
    return;
  }

  scrollToSection(sectionId);
}

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.panel}>
        <div className={styles.brandBlock}>
          <span className={styles.kicker}>Sylvie Willms.</span>
          <h2 className={styles.brand}>Sylvie Willms</h2>
          <p className={styles.baseline}>Numéro de liberté, pension, travail du cheval, accueil à domicile.</p>
          <a className={styles.mailLink} href="mailto:contact@sylviewillms.com">
            contact@sylviewillms.com
          </a>
        </div>

        <div className={styles.columns}>
          <section className={styles.column}>
            <h3 className={styles.heading}>Contact.</h3>
            <p className={styles.copy}>Programmation, presse, partenariats.</p>
          </section>

          <section className={styles.column}>
            <h3 className={styles.heading}>Accès.</h3>
            <div className={styles.linkList}>
              {quickLinks.map((link) => (
                <button
                  className={styles.navLink}
                  key={link.id}
                  onClick={() => {
                    openSection(link.id);
                  }}
                  type="button"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </section>

          <section className={styles.column}>
            <h3 className={styles.heading}>Réseaux.</h3>
            <div className={styles.linkList}>
              {socialLinks.map((link) => (
                <a
                  className={styles.socialLink}
                  href={link.href}
                  key={link.id}
                  rel="noreferrer"
                  target="_blank"
                >
                  <span className={styles.socialHead}>
                    <span className={styles.socialIconWrap}><SocialIcon platform={link.platform} /></span>
                    <span>{link.label}</span>
                  </span>
                  <span className={styles.socialHandle}>{link.value}</span>
                </a>
              ))}
            </div>
          </section>
        </div>

        <div className={styles.bottomBar}>
          <span className={styles.legal}>Sylvie Willms - {currentYear} - Tous droits réservés.</span>
          <span className={styles.signature}>T.T. Développement</span>
        </div>
      </div>
    </footer>
  );
};
